var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgBoltGreen = function SvgBoltGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.558 11.22l4.083-5.525C9.28 2.125 10.6.34 11.83.716c1.23.378 1.23 2.567 1.23 6.947v.413c0 1.58 0 2.37.506 2.865l.026.025c.516.485 1.338.485 2.982.485 2.959 0 4.438 0 4.938.897l.024.045c.472.912-.385 2.07-2.098 4.388l-4.083 5.524c-2.639 3.57-3.958 5.356-5.19 4.979-1.23-.377-1.23-2.567-1.23-6.947v-.413c0-1.58 0-2.369-.505-2.864l-.027-.026c-.516-.485-1.338-.485-2.982-.485-2.958 0-4.437 0-4.937-.897a1.444 1.444 0 01-.024-.045c-.472-.911.384-2.07 2.097-4.388z",
    fill: "url(#bolt_green_svg__paint0_linear_2438_8656)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bolt_green_svg__paint0_linear_2438_8656",
    x1: 10.999,
    y1: 0.667,
    x2: 10.999,
    y2: 27.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DD181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FFFCB"
  })))));
};
export default SvgBoltGreen;